// frontend/src/modules/folha/components/HoleriteFooter.js
import React from 'react';

function HoleriteFooter({ empresa, dataPagamento, status }) {
  const dataAtual = new Date().toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <div style={{
      marginTop: '30px',
      paddingTop: '20px',
      borderTop: '2px solid #333',
      fontSize: '11px',
      color: '#6c757d'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div>
          <p style={{ margin: '2px 0' }}>
            <strong>Data Pagamento:</strong> {dataPagamento}
          </p>
          <p style={{ margin: '2px 0' }}>
            <strong>Status:</strong> {status}
          </p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <p style={{ margin: '2px 0' }}>
            <strong>Documento emitido em:</strong> {dataAtual}
          </p>
          <p style={{ margin: '2px 0', color: '#adb5bd' }}>
            Este documento é um comprovante de pagamento.
          </p>
        </div>
      </div>
      
      {/* Assinaturas */}
      <div style={{
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <div style={{ textAlign: 'center', flex: 1, minWidth: '150px' }}>
          <div style={{
            borderTop: '1px solid #333',
            paddingTop: '5px',
            marginTop: '20px',
            width: '80%',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            <p style={{ margin: 0, fontSize: '11px', color: '#333' }}>
              {empresa?.nome_fantasia || empresa?.nome_empresa || 'Empresa'}
            </p>
            <p style={{ margin: 0, fontSize: '10px', color: '#6c757d' }}>
              Representante Legal
            </p>
          </div>
        </div>
        <div style={{ textAlign: 'center', flex: 1, minWidth: '150px' }}>
          <div style={{
            borderTop: '1px solid #333',
            paddingTop: '5px',
            marginTop: '20px',
            width: '80%',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            <p style={{ margin: 0, fontSize: '11px', color: '#333' }}>Funcionário</p>
            <p style={{ margin: 0, fontSize: '10px', color: '#6c757d' }}>
              Ciente e de acordo
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HoleriteFooter;